import '@shoelace-style/shoelace/dist/components/animation/animation';
import '@shoelace-style/shoelace/dist/components/animation/animations';
import '@shoelace-style/shoelace/dist/components/carousel-item/carousel-item';
import '@shoelace-style/shoelace/dist/components/carousel/carousel';
import '@shoelace-style/shoelace/dist/components/tag/tag';
import '@shoelace-style/shoelace/dist/shoelace.js';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../components/promo-donut';
import '../../components/search-query';

import { RootState, store } from '../../store';
import { styles as sharedStyles } from '../../styles/shared-styles';
import { searchStyles, sectionStyles, shopStyles, tabStyles, tagsStyles } from './welcome-styles';
// import { selectUser, AppUser } from '../../state/users';

import { Unsubscribe } from '@reduxjs/toolkit';
import { repeat } from 'lit/directives/repeat.js';
import { CategoryStats, ProductSearchQueryArgs, ProductStats, ProductStatsQuery, ProductsQuery } from '../../api/models';
import { selectProductSearchQuery, selectProductStatsQuery } from '../../api/products';
import { SHOPS } from '../../constants';
import { NavigateEvent } from '../../events';
import { switchLayout } from '../../media-query';
import { resolveRouterPath } from '../../router';
import { Layout, selectLayout, selectProductSearchQueryArgs } from '../../state/pages';

@customElement('app-welcome')
export class AppWelcome extends LitElement {

  static styles = [
    sharedStyles,
    sectionStyles,
    shopStyles,
    tagsStyles,
    searchStyles,
    // productStyles,
    tabStyles,
    css`
    :host {
      display: block;
      box-sizing: border-box;
      padding: 0px;
      margin: 0px;
      background-color: transparent;
    }


    `
  ]

  @property({ attribute: false, state: true, type: Object })
  private layout: Layout = Layout.PHONE;

  @property({ attribute: false, state: true, type: Object })
  private productSearchQueryArgs: ProductSearchQueryArgs = {};

  @property({ attribute: false, state: true, type: Object })
  private productsSearchQuery: ProductsQuery | null = null;

  @property({ attribute: false, state: true, type: Object })
  private productStatsQuery: ProductStatsQuery | null = null;

  // @property({ attribute: false, state: true, type: Array })
  // private favorites: boolean[] = [] as boolean[];

  // renderProducts() {
  //   return html`
  //     <div class=${switchLayout(this.layout, "product-slideshow phone", "product-slideshow tablet", "product-slideshow laptop", "product-slideshow desktop")}>
  //       <div class=${switchLayout(this.layout, "slideshow-container phone", "slideshow-container tablet", "slideshow-container laptop", "slideshow-container desktop")}>
  //         ${repeat(this.productsSearchQuery?.data?.results.slice(0, 50) || [], (productSearchResult: ProductSearchResult, index: number) => html`
  //         <product-searchresult .productSearchResult=${productSearchResult} ?favorite=${this.favorites[index]} .layout=${Layout.PHONE}></product-searchresult>
  //         `)}
  //       </div>
  //     </div>
  //     `;
  // }

  // private renderWatchlist() {
    
  // }

  renderShopPromos(shop: string) {
    const stats: ProductStats | null = (this.productStatsQuery?.data?.shopStats || []).find(stat => stat.shop === shop) || null;
    return html`
    <div class="shop" href="${resolveRouterPath(`/shops/${shop}`)}"  @click=${this.clickElementWithHref}>
     <img src=${resolveRouterPath(SHOPS[shop as keyof typeof SHOPS].icon)} alt="${shop}"/>
     <promo-donut .stats=${stats}></promo-donut>
    </div>`;
  }

  renderShopsPromos() {
    return html`
        <!-- <sl-animation name="tada" duration="1500" iterations="3" play>
        <sl-tag variant="danger" size=${switchLayout(this.layout, "small", "small", "medium", "large")}>
            "PROMO 50% of meer"
        </sl-tag>
        </sl-animation> -->
        
        <div class=${switchLayout(this.layout, "shops-section phone", "shops-section tablet", "shops-section laptop", "shops-section desktop")}>

        ${repeat(Object.keys(SHOPS), (shop: string) => this.renderShopPromos(shop))}

        </div>
    `;
  }

  renderSearch() {
    return html`
    <div class=${switchLayout(this.layout, "section phone", "section tablet", "section laptop", "section desktop")}>
        <div class=${switchLayout(this.layout, "search-section phone", "search-section tablet", "search-section laptop", "search-section desktop")} >
          <div class=${switchLayout(this.layout, "title phone", "title tablet", "title laptop", "title desktop")}>
            <h3>Supermarktprijzen</h3>
          </div>
          <div class=${switchLayout(this.layout, "section-title phone", "section-title tablet", "section-title laptop", "section-title desktop")}>
            <search-query .layout=${this.layout} query=""></search-query>
        </div>
    </div>
    `;
  }

  renderTags() {
    const stats: CategoryStats[] = (this.productStatsQuery?.data?.categoryStats || []).filter(stat => stat.level === 1);
    return html`
        <sl-tab-group>
          <sl-tab slot="nav" panel="categories"><sl-icon name="tags"></sl-icon>Categories</sl-tab>
          <sl-tab-panel name="categories">
          <div class=${switchLayout(this.layout, "tags-section phone", "tags-section tablet", "tags-section laptop", "tags-section desktop")} >

          ${repeat(stats, (tag: CategoryStats) => html`
            <div class=${switchLayout(this.layout, "tag-button phone", "tag-button tablet", "tag-button laptop", "tag-button desktop")} href="${resolveRouterPath(`/categories/${tag.category}`)}" @click=${this.clickElementWithHref}>
                ${tag.category}<sl-icon style="color: lightgreen" name="tag-fill"></sl-icon>
            </div>`)}
            </div>
        </sl-tab-panel>
        </sl-tab-group>
    `;
  }

  render() {
    return html`
      <!-- <search-navigation .layout=${this.layout} .productStatsQuery=${this.productStatsQuery} .productsSearchQuery=${this.productsSearchQuery}></search-navigation> -->
      <div class="welcome-sections">
        ${this.renderShopsPromos()}
        ${this.renderSearch()}
        ${this.renderTags()}
      </div>
      ${this.renderStructuredData()}
    `;
  }

  private stateUnsubscribe: Unsubscribe = () => { };

  stateChanged(state: RootState) {
    this.layout = selectLayout(state);
    this.productSearchQueryArgs = selectProductSearchQueryArgs(store.getState());
    this.productsSearchQuery = selectProductSearchQuery(state, this.productSearchQueryArgs);
    this.productStatsQuery = selectProductStatsQuery(state);
    // this.favorites = (this.productsSearchQuery?.data?.results || []).map(result => {
    //   if (result.shop && result.product_ref) return isInlist(state, result.shop, result.product_ref);
    //   else return false;
    // });
  }

  connectedCallback() {
    super.connectedCallback();
    this.stateUnsubscribe = store.subscribe(() => {
      const state = store.getState();
      this.stateChanged(state);
    });
    // update immediately
    const state = store.getState();
    this.stateChanged(state);
  }

  clickElementWithHref(event: TouchEvent) {
    event.preventDefault();
    const clickedItem: HTMLElement = event.currentTarget as HTMLElement;
    const url: string = clickedItem.getAttribute("href") as string;
    this.dispatchEvent(new NavigateEvent({ url }));
  }



  disconnectedCallback() {
    this.stateUnsubscribe();
  }

  renderStructuredData() {
    const stats: CategoryStats[] = this.productStatsQuery?.data?.categoryStats || [];
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Supermarktprijzen Welcome Page",
      "description": "Find the best supermarket prices and promotions",
      "mainEntity": [
        {
          "@type": "ItemList",
          "name": "Featured Products",
          "itemListElement": this.productsSearchQuery?.data?.results.slice(0, 50).map((product, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
              "@type": "Product",
              "name": product.product_name,
              "url": `${window.location.origin}/productId/${product.productId}/${product.product_name}`,
              "image": product.imageUrl
            }
          })) || []
        },
        {
          "@type": "ItemList",
          "name": "Shops",
          "itemListElement": Object.keys(SHOPS).map((shop, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
              "@type": "Organization",
              "name": SHOPS[shop as keyof typeof SHOPS].name,
              "url": resolveRouterPath(`/shops/${shop}`)
            }
          }))
        },
        {
          "@type": "ItemList",
          "name": "Categories",
          "itemListElement": stats.map((stat, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
              "@type": "Thing",
              "name": stat.category,
              "url": resolveRouterPath(`/categories/${stat.category}`)
            }
          }))
        }
      ]
    };

    return html`
      <script type="application/ld+json">
        ${JSON.stringify(structuredData)}
      </script>
    `;
  }
}
